import React from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import { Helmet } from "react-helmet";

import styled from "@emotion/styled";
import { css } from "@emotion/react";

import NavItem from "@ats/src/components/shared/NavItem";
import JobDistributionWeWorkRemotely from "@ats/src/views/jobApplications/jobDistribution/JobDistributionWeWorkRemotely";
import JobDistributionWhatJobs from "@ats/src/views/jobApplications/jobDistribution/JobDistributionWhatJobs";
import JobDistributionXHiring from "@ats/src/views/jobApplications/jobDistribution/JobDistributionXHiring";
import JobDistributionLinkedIn from "@ats/src/views/jobApplications/jobDistribution/JobDistributionLinkedIn";

import { FeatureFlipper } from "@ats/src/components/shared/FeatureFlipper";
import { useFeatureGate } from "@shared/hooks/useFeatureGate";
import { PlanFeatures } from "@shared/types/organization";
import { useBoardWhatJobsListings } from "@shared/queryHooks/useWhatJobsListing";

function JobDistributionContainer(props) {
  const { match, job } = props;
  const { getFeatureInfo } = useFeatureGate();
  const linkedInFeature = getFeatureInfo(PlanFeatures.LINKEDIN_FEED);

  const {
    data: whatJobsListingsData,
    isLoading: isLoadingWhatJobsListings,
  } = useBoardWhatJobsListings(job?.id);

  const whatJobsListing =
    whatJobsListingsData && whatJobsListingsData.length > 0 ? whatJobsListingsData[0] : null;

  return (
    <>
      <Helmet title="Distribution" />
      <Styled.Container>
        <Styled.Sidebar>
          <NavItem to={`${match.url}/weworkremotely`} label="We Work Remotely" chevron />
          <FeatureFlipper feature="WHATJOBS_INTEGRATION">
            <NavItem to={`${match.url}/whatjobs`} label="WhatJobs?" chevron />
          </FeatureFlipper>
          <NavItem to={`${match.url}/xhiring`} label="X Hiring" chevron />
          <NavItem
            to={`${match.url}/linkedin`}
            label="LinkedIn"
            chevron
            locked={linkedInFeature.isLocked}
            upgradePlanKey={linkedInFeature.upgradePlanKey}
            planDisplayName={linkedInFeature.planDisplayName}
          />
        </Styled.Sidebar>
        <Styled.Content>
          <Switch>
            <Route
              path={`${match.path}/weworkremotely`}
              render={(renderProps) => (
                <JobDistributionWeWorkRemotely {...props} {...renderProps} />
              )}
            />
            <Route
              path={`${match.path}/whatjobs`}
              render={(renderProps) => (
                <JobDistributionWhatJobs
                  {...props}
                  {...renderProps}
                  currentListing={whatJobsListing}
                  isLoadingCurrentListing={isLoadingWhatJobsListings}
                />
              )}
            />
            <Route
              path={`${match.path}/xhiring`}
              render={(renderProps) => <JobDistributionXHiring {...props} {...renderProps} />}
            />
            <Route
              path={`${match.path}/linkedin`}
              render={(renderProps) => <JobDistributionLinkedIn {...props} {...renderProps} />}
            />
            <Redirect to={`${match.path}/weworkremotely`} />
          </Switch>
        </Styled.Content>
      </Styled.Container>
    </>
  );
}

export default JobDistributionContainer;

/* Styled Components
======================================================= */
let Styled: any;
Styled = {};

Styled.Container = styled.div`
  label: JobSetupContainer;
  display: flex;
  height: 100%;
`;

Styled.Sidebar = styled.div((props) => {
  const t: any = props.theme;
  return css`
    label: JobDistributionContainer_Sidebar;
    color: ${t.dark ? t.color.gray[400] : t.color.gray[600]};
    border-right: 1px solid ${t.dark ? t.color.gray[800] : t.color.gray[200]};
    width: 21.5909091%;
    padding-top: 0.375rem;
  `;
});

Styled.Content = styled.div`
  label: JobDistributionContainer_Content;
  width: 78.4090909%;
  height: 100%;
  overflow-y: auto;
  position: relative;
`;
